<template>
    <b-overlay :show="loading" rounded="sm">
        <b-card>
            <b-form @submit.stop.prevent="submit">

                <!-- Field -->
                <b-form-group
                    label="Tema da Plataforma">
                    <!-- Input -->
                    <b-form-select
                        v-model="form.theme"
                        :options="themesOptions"
                        :state="hasErrors('theme', errors)" />

                    <!-- Error -->
                    <has-errors :errors="errors" name="theme" />
                </b-form-group>

                <!-- Field -->
                <b-form-group
                    label="Logo da Escola"
                    description="Aqui você faz o upload da imagem da sua marca. Por exemplo, imagens com pelo menos 80x80 pixels se adaptam melhor.">

                    <!-- Input -->
                    <b-form-file
                        ref="logo_path"
                        @change="loadFile($event, 'logo_path')"
                        accept="image/*"
                        placeholder=""
                        browse-text="Procurar"
                        no-drop
                    ></b-form-file>

                    <!-- Preview -->
                    <div class="row" v-if="preview">
                        <div class="col-sm-4 mt-2">
                            <img :src="preview" class="img-thumbnail" alt="LogoTipo"/>
                        </div>
                    </div>

                    <!-- Error -->
                    <has-errors :errors="errors" name="logo_path" />
                </b-form-group>

                <!-- Field -->
                <b-form-group
                    label="Folha de Redação"
                    description="Aqui você pode fazer upload da sua folha de redação em pdf.">

                    <!-- Input -->
                    <b-form-file
                        ref="logo_path"
                        @change="loadFile($event, 'leaf_path')"
                        accept="application/pdf"
                        placeholder=""
                        browse-text="Procurar"
                        no-drop
                    ></b-form-file>

                    <!-- Preview -->
                    <div class="row" v-if="leaf_preview">
                        <div class="col-sm-12 mt-2">
                            <a :href="leaf_preview" target="_blank">
                                <i class="fas fa-file-pdf mr-1"></i>
                                Visualizar Folha de Redação Atual
                            </a>
                        </div>
                    </div>

                    <!-- Error -->
                    <has-errors :errors="errors" name="leaf_path" />
                </b-form-group>

                <!-- Field -->
                <b-form-group
                    label="Imagem de Destaque na Tela de Autenticação"
                    description="Aqui você faz o upload da imagem que ficará em destaque no login. Para um melhor aproveitamento em todos os tamanhos de tela, recomendamos a proporção de no mínimo 700x812 pixels.">

                    <!-- Input -->
                    <b-form-file
                        ref="auth_bg_path"
                        @change="loadFile($event, 'auth_bg_path')"
                        accept="image/*"
                        placeholder=""
                        browse-text="Procurar"
                        no-drop
                    ></b-form-file>

                    <!-- Preview -->
                    <div class="row" v-if="auth_bg_preview">
                        <div class="col-sm-4 mt-2">
                            <img :src="auth_bg_preview" class="img-thumbnail" alt="Imagem de Destaques Login"/>
                        </div>
                    </div>

                    <!-- Error -->
                    <has-errors :errors="errors" name="auth_bg_path" />
                </b-form-group>

                <!-- Field -->
                <b-form-group
                    label="Ícone da Plataforma (Favicon)"
                    description="Essa imagem fica no título da página e pode ser alterada para suportar uma imagem personalizada">

                    <!-- Input -->
                    <b-form-file
                        ref="favicon_path"
                        @change="loadFile($event, 'favicon_path')"
                        accept="image/*"
                        placeholder=""
                        browse-text="Procurar"
                        no-drop
                    ></b-form-file>

                    <!-- Preview -->
                    <div class="row" v-if="favicon_preview">
                        <div class="col-sm-4 mt-2">
                            <img :src="favicon_preview" class="img-thumbnail" alt="Favicon"/>
                        </div>
                    </div>

                    <!-- Error -->
                    <has-errors :errors="errors" name="favicon_path" />
                </b-form-group>

                <!-- Submit -->
                <b-button type="submit" variant="primary" :disable="loading">
                    Atualizar
                </b-button>
            </b-form>
        </b-card>
    </b-overlay>
</template>

<script>
export default {
    props: [],
    data() {
        return {
            loading: false,
            errors: {},
            actual_organization: {},
            form: {
                theme: null,
                logo_path: null,
                auth_bg_path: null,
                favicon_path: null,
                leaf_path: null
            },
            preview: null,
            auth_bg_preview: null,
            favicon_preview: null,
            leaf_preview: null,
            themesOptions: [
                {
                    value: 'default',
                    text: 'Padrão'
                },
                {
                    value: 'green',
                    text: 'Verde'
                },
                {
                    value: 'green-light',
                    text: 'Verde Claro'
                },
                {
                    value: 'red',
                    text: 'Vermelho'
                },
                {
                    value: 'yellow',
                    text: 'Amarelo'
                },
                {
                    value: 'purple',
                    text: 'Roxo'
                },
                {
                    value: 'blue',
                    text: 'Azul'
                },
                {
                    value: 'beige',
                    text: 'Berge Padrão'
                },
                {
                    value: 'beige2',
                    text: 'Rosa'
                },
                {
                    value: 'pink-red',
                    text: 'Rosa Avermelhado'
                },
                {
                    value: 'dark-pink',
                    text: 'Rosa Escuro'
                },
                {
                    value: 'orange',
                    text: 'Laranja'
                },
                {
                    value: 'black',
                    text: 'Preto'
                },
            ],
        }
    },
    created() {

        this.load();

    },
    methods: {

        load() {
            this.loading = true;
            axios.get('/teacher/organization?complete=true')
                .then((result) => {
                    const response = result.data.data

                    this.actual_organization = response.actual_organization;

                    this.form.theme = response.actual_organization.theme

                    this.preview = response.actual_organization.preview
                    this.auth_bg_preview = response.actual_organization.auth_bg_preview
                    this.favicon_preview = response.actual_organization.favicon_preview
                    this.leaf_preview = response.actual_organization.leaf_preview
                })
                .finally(() => this.loading = false)
        },

        submit() {
            this.loading = true;

            const data = new FormData();
            data.append('theme', this.form.theme);

            if (this.form.logo_path) {
                data.append('logo_path', this.form.logo_path);
            }

            if (this.form.auth_bg_path) {
                data.append('auth_bg_path', this.form.auth_bg_path);
            }

            if (this.form.favicon_path) {
                data.append('favicon_path', this.form.favicon_path);
            }

            if (this.form.leaf_path) {
                data.append('leaf_path', this.form.leaf_path);
            }

            axios.post('/teacher/organization/theme', data)
                .then((result) => {
                    // Redirect
                    this.redirectIfNeed(result)

                    // Clear Errors
                    this.errors = {}
                })
                .catch((errors) => {
                    // Check Errors
                    this.errors = this.setErrors(errors)
                })
                .finally(() => this.loading = false)
        },

        loadFile(event, field, maxSize = 8) {

            const input = event.target;
            if (input.files && input.files[0]) {

                const mbSize = input.files[0].size/1024/1024

                if(mbSize > maxSize){
                    this.form[field] = null
                    let data = {}
                    data[field]= [`Tamanho do arquivo maior que ${maxSize} mb, o arquivo não será enviado!`]

                    this.errors = data
                }else{
                    this.form[field] = input.files[0];
                }

            } else {
                this.form[field] = null
            }
        }

    }
}
</script>

<style scoped>

</style>
